// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HIK42ZHBFLANGN {
  display: flex;
  box-sizing: border-box;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: var(--ds-space-300, 24px);
  background-color: var(--tr-background-list);
}
`, ""]);
// Exports
export var container = `HIK42ZHBFLANGN`;
export default ___CSS_LOADER_EXPORT___;
